import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

// Interfaces for city, state, and country
export interface City {
  id: number;
  name: string;
  stateId: number;
}

export interface State {
  id: number;
  name: string;
  countryId: number;
  cities: City[];
}

export interface Country {
  id: number;
  name: string;
  code: string | null;
  states: State[];
}

export interface countriesState {
  totalRecords: number | null;
  data: Country[] | null;
  totalPages: number | null;
  currentPage: number | null;
  states: State[];
  cities: City[];
}

const initialState: countriesState = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
  states: [],
  cities: [],
};

export const countriesSlice = createSlice({
  name: 'countries',
  initialState,
  reducers: {
    setCountries: (
      state: countriesState,
      action: PayloadAction<{ data: Country[]; totalRecords: number; currentPage: number; totalPages: number }>
    ) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.totalRecords;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;

      state.states = [];
      state.cities = [];
      //console.log('Countries set:', state.data);
    },

    addNewCountries: (
      state: countriesState,
      action: PayloadAction<{ data: Country }>
    ) => {
      state.data = state.data ? [action.payload.data, ...state.data] : [action.payload.data];
      console.log('New country added:', action.payload.data);
    },

    reset: (state) => {
      return { ...initialState };
    },
  },
});

export const { setCountries, addNewCountries, reset } = countriesSlice.actions;

export default countriesSlice.reducer;
